import { CBadge } from "@coreui/react";
import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as ChevronDown } from "../../../assets/icons/ChevronDown.svg";

const MenuItem = ({
  children,
  href,
  text,
  selected = false,
  onClick = () => {},
  count = null,
  collapsible = false,
}) => {
  return (
    <Link
      onClick={onClick}
      to={href}
      className={`menu ${selected ? "menu-item-selected" : "menu-item"}`}
    >
      <div className="menu-container">
        <div>{children}</div>
        <span className="menu-item-text">{text}</span>
      </div>
      {collapsible && (
        <span className="text-white menu-item-text">
          <ChevronDown />
        </span>
      )}
      {count > 0 && window.location.pathname !== "/chat/" && (
        <CBadge shape="rounded-pill" className="unread-message-pill">
          <small>{count > 0 ? count : null}</small>
        </CBadge>
      )}
    </Link>
  );
};

export const ThirdPartyMenuItem = ({
  children,
  href,
  text,
  selected = false,
  onClick = () => {},
  count = null,
  collapsible = false,
}) => {
  return (
    <Link
      onClick={onClick}
      to={href}
      target="blank"
      className={`menu ${selected ? "tp-menu-item-selected" : "tp-menu-item"}`}
      style={{ justifyContent: "space-evenly" }}
    >
      <div className="menu-container">
        <div>{children}</div>
        <span className="tp-menu-item-text">{text}</span>
      </div>
      {collapsible && (
        <span className="tp-menu-item-text">
          <ChevronDown />
        </span>
      )}
      {count > 0 && window.location.pathname !== "/chat/" && (
        <CBadge shape="rounded-pill" className="unread-message-pill">
          <small>{count > 0 ? count : null}</small>
        </CBadge>
      )}
    </Link>
  );
};

export const MiniMenuItem = ({
  children,
  href,
  text,
  selected = false,
  onClick = () => {},
  count = null,
  toggleCollapse = null,
}) => {
  return (
    <Link
      onClick={onClick}
      to={href}
      className={`menu ${
        selected ? "mini-menu-item-selected" : "mini-menu-item"
      }`}
    >
      <div className="menu-container">
        <div style={{ margin: "0px", padding: "0px" }}>{children}</div>
        <span className="mini-menu-item-text">{text}</span>
      </div>
      {toggleCollapse && (
        <span className="text-white mini-menu-item-text">{`˅`}</span>
      )}
      {count > 0 && window.location.pathname !== "/chat/" && (
        <CBadge shape="rounded-pill" className="unread-message-pill">
          <small>{count > 0 ? count : null}</small>
        </CBadge>
      )}
    </Link>
  );
};

export default MenuItem;
